import React from 'react';
import MaterialTable from 'material-table';
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    filterTable:{
        '& .MuiTableCell-head': {
            color: '#fff',
            fontSize: '17px',
            background: 'rgba(36, 97, 142, 1)',
        },
        '& .MuiTableCell-head:nth-child(2)':{
            textAlign:'center',        
            },
       '& .MuiTableCell-body:nth-child(2)':{
        textAlign:'center', 
       }      
    }
  }));

const tableIcons = {   
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
  };

const FilterData = ()=>{
    const classes = useStyles();    
    return (
        <div className={classes.filterTable}>
        <MaterialTable        
          icons={tableIcons}
          title=""
          columns={[
            { title: 'Name', field: 'name' },
            { title: 'No Of Users', field: 'noOfUsers' , type: 'numeric'},
            { title: 'Description', field: 'description' },
          
          ]}
          data={[
            { name: 'Admins', noOfUsers: 2, description: 'Site Admins' },
            { name: 'Data Approvers', noOfUsers: 5, description: 'Employees who can approve data imports' },
            { name: 'Data Importers', noOfUsers: 2, description: 'Site members who can import data to stations' },
            { name: 'Detailed Station Data View', noOfUsers: 26, description: 'Site members who can view detailed station data' },
            
          ]}        
          options={{
            filtering: false,
            sorting:false
          }}
        />
        </div>
      )
}

export default FilterData;